import React from 'react';

import Paragraph from '../../ui/Typography/Paragraph';
import { $l } from '../../../locales';

const ChatIsClosed = () => (
  <Paragraph fontSize="12" align="center">
    {$l('CLOSED_CHAT_TITLE')}
    <br />
    {$l('CLOSED_CHAT_TEXT')}
  </Paragraph>
);

export default ChatIsClosed;
